<template>
  <v-container grid-list-md>
    <v-layout wrap>
      <v-flex xs12 style="margin-top: 20px">
        <p v-if="$vuetify.breakpoint.xs" :class="$vuetify.breakpoint.smAndDown ? 'h2' : 'h1'">Quem Somos</p>

        <p :class="$vuetify.breakpoint.smAndDown ? 'p16' : 'p20'" v-html="$store.state.sobre1"></p>
      </v-flex>

      <v-flex xs12 v-if="$vuetify.breakpoint.mdAndUp">
        <v-responsive :aspect-ratio="16 / 9" style="width: 100vw">
          <video autoplay muted loop playsinline style="width: 100%; height: 100%; object-fit: cover">
            <source v-bind:src="quemsomos" type="video/mp4" />
          </video>
        </v-responsive>
      </v-flex>
      <v-flex xs12 v-if="$vuetify.breakpoint.smAndDown">
        <v-responsive :aspect-ratio="9 / 16" style="width: 100vw">
          <video autoplay muted loop playsinline style="width: 100%; height: 100%; object-fit: cover">
            <source v-bind:src="quemsomos" type="video/mp4" />
          </video>
        </v-responsive>
      </v-flex>

      <v-flex xs12 style="margin-top: 20px">
        <p :class="$vuetify.breakpoint.smAndDown ? 'p16' : 'p20'" v-html="$store.state.sobre2"></p>
      </v-flex>

      <v-flex xs12 style="margin-top: 20px">
        <p :class="$vuetify.breakpoint.smAndDown ? 'p16' : 'p20'" v-html="$store.state.sobre3"></p>
      </v-flex>

      <v-flex xs12 style="margin-top: 20px">
        <p :class="$vuetify.breakpoint.smAndDown ? 'p16' : 'p20'" v-html="$store.state.sobre4"></p>
      </v-flex>

      <v-flex xs12 style="margin-top: 20px">
        <p :class="$vuetify.breakpoint.smAndDown ? 'p16' : 'p20'" v-html="$store.state.sobre5"></p>
      </v-flex>

      <v-flex xs12 :style="`height: ${$vuetify.breakpoint.xs ? '80px' : '60px'};`"></v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    quemsomos() {
      return process.env.VUE_APP_URL_API + `arquivos/QuemSomos.mp4`;
    }
  }
};
</script>
